import { Injectable } from '@angular/core';
import { UnRx } from '@pebula/utils';

@Injectable()
@UnRx()
export class SgLimitService {
  maxSubLegalEntitiesLimit = 1000;
  constructor() {}
}
